
import { Injectable } from "@angular/core";
import { CountryService } from "../../global-services/country.service";
import { CountryModel } from "../../global-data-models/country.model";
import { GlobalMessageService } from "../../global-services/global-message.service";
import { Misc } from "../../global-misc/misc";
import { BehaviorSubject } from "rxjs";

export interface PhoneInputState {
    countries: CountryModel[];
}

@Injectable({
    providedIn: "root"
})
export class GlobalPhoneInputFacade {

    private phoneInputState$ = new BehaviorSubject<PhoneInputState>({
        countries: []
    });

    readonly state$ = this.phoneInputState$.asObservable();

    public constructor(
        private readonly countryService: CountryService,
        private readonly messageService: GlobalMessageService
    ) { }

    public async loadCountries(): Promise<void> {
        try {
            const countries: CountryModel[] = await this.countryService.getAllCountries();
            this.updateState({ countries });
        } catch (error: unknown) {
            const errMsg: string = Misc.getErrorMessage(error);
            this.messageService.showError("PhoneInput GetCountries Error", errMsg);
            this.updateState({ countries: [] });
        }
    }

    public async getCountries(): Promise<CountryModel[]> {
        try {
            const countries: CountryModel[] = await this.countryService.getAllCountries();
            return countries;
        } catch (error: unknown) {
            const errMsg: string = Misc.getErrorMessage(error);
            this.messageService.showError("PhoneInput GetCountries Error", errMsg);
            return [];
        }
    }

    private updateState(partialState: Partial<PhoneInputState>): void {
        this.phoneInputState$.next({ ...this.phoneInputState$.value, ...partialState });
    }
}